export class ParameterRequestTO {
	public nombreParametro!: String;
	public valorParametro!: String;
}